import { SENDER_CHANNEL } from "./constants";

export const DEFAULT_SMS_FROM_NUMBER = "90008361";

export const defaultProfileForm = () => ({
    id: null,
    name: "",
    channel: SENDER_CHANNEL.EMAIL,
    fromEmail: "",
    fromNumber: DEFAULT_SMS_FROM_NUMBER,
    showAdvanced: false,
    advancedConfig: "{}",
    active: true,
});

export const buildProfileConfig = (form) => {
    if (form.showAdvanced) {
        return JSON.parse(form.advancedConfig || "{}");
    }

    if (form.channel === SENDER_CHANNEL.EMAIL) {
        const config = {};
        const fromEmail = form.fromEmail.trim();
        if (fromEmail) config.from_email = fromEmail;
        return config;
    }

    if (form.channel === SENDER_CHANNEL.SMS) {
        const config = {};
        const fromNumber = form.fromNumber.trim();
        if (fromNumber) config.from_number = fromNumber;
        return config;
    }

    return {};
};

export const defaultAdvancedConfig = (channel) => {
    if (channel === SENDER_CHANNEL.EMAIL) {
        return JSON.stringify({ from_email: "" }, null, 2);
    }
    if (channel === SENDER_CHANNEL.SMS) {
        return JSON.stringify(
            { from_number: DEFAULT_SMS_FROM_NUMBER },
            null,
            2
        );
    }
    return "{}";
};

export const formatProfileConfigSummary = (profile) => {
    const config = profile.config || {};

    if (profile.channel === SENDER_CHANNEL.EMAIL) {
        return config.from_email || "—";
    }
    if (profile.channel === SENDER_CHANNEL.SMS) {
        return config.from_number || "—";
    }
    return "—";
};

const hasOnlyKeys = (config, keys) =>
    Object.keys(config).every((key) => keys.includes(key));

export const profileToForm = (profile) => {
    const config = profile.config || {};
    const channel = profile.channel;
    const base = {
        id: profile.id,
        name: profile.name || "",
        channel,
        active: profile.active !== false,
    };

    if (
        channel === SENDER_CHANNEL.EMAIL &&
        hasOnlyKeys(config, ["from_email"])
    ) {
        return {
            ...base,
            fromEmail: config.from_email || "",
            fromNumber: DEFAULT_SMS_FROM_NUMBER,
            showAdvanced: false,
            advancedConfig: defaultAdvancedConfig(channel),
        };
    }

    if (
        channel === SENDER_CHANNEL.SMS &&
        hasOnlyKeys(config, ["from_number"])
    ) {
        return {
            ...base,
            fromEmail: "",
            fromNumber: config.from_number || DEFAULT_SMS_FROM_NUMBER,
            showAdvanced: false,
            advancedConfig: defaultAdvancedConfig(channel),
        };
    }

    if (channel === SENDER_CHANNEL.IN_APP && hasOnlyKeys(config, [])) {
        return {
            ...base,
            fromEmail: "",
            fromNumber: DEFAULT_SMS_FROM_NUMBER,
            showAdvanced: false,
            advancedConfig: defaultAdvancedConfig(channel),
        };
    }

    return {
        ...base,
        fromEmail: config.from_email || "",
        fromNumber: config.from_number || DEFAULT_SMS_FROM_NUMBER,
        showAdvanced: true,
        advancedConfig: JSON.stringify(config, null, 2),
    };
};
